<!-- 排出事業者 費目 -->
<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-row>
          <v-col>
            <div class="text-right mb-3">
              <v-btn
                color="primary"
                @click="addButtonClickEvent"
              >
                取扱品目の追加&nbsp;<v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
            <v-card outlined class="rounded-card">
              <v-data-table
                :headers="tableHeaders"
                :items="items"
                :items-per-page="-1"
                dense
                disable-sort
                hide-default-footer
              >
                <template v-slot:[`item.editable`]="{ item }">
                  <v-btn
                    v-if="$vuetify.breakpoint.mdAndUp"
                    color="error"
                    icon
                    small
                    @click="deleteButtonClickEvent(item)"
                  >
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                  <v-btn
                    v-else
                    color="error"
                    small
                    @click="deleteButtonClickEvent(item)"
                  >
                    削除
                  </v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-pagination
              v-model="page"
              :length="pagination.total_pages"
              :total-visible="totalVisible"
              circle
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              @input="changePage"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <item-dialog
      :enable-dialog="enableItemDialog"
      :emission-id="emissionId"
      @closeEvent="closeItemDialog"
      @registerEvent="itemDialogCallback"
    />
    <confirm ref="confirm" />
  </div>
</template>

<script>

import ItemDialog from '../dialogs/_ItemDialog'
import Confirm from "../../../../../components/Confirm";
import {mapActions} from "vuex";
export default {


  name: 'EmissionItemForm',
  components: {
    ItemDialog,
    Confirm,
  },
  mixins: [],
  props: {},
  data () {
    return {
      page: 1,
      totalVisible: 7,
      pagination: {
        total_pages: 0,
        total_count: 0
      },
      enableItemDialog: false,
      emissionId: null,
      tableHeaders: [
        { value: 'code', text: 'コード' },
        { value: 'name', text: '取扱品目' },
        { value: 'hierarchy', text: '分類' },
        { value: 'editable', text: '', align: 'end' },
      ],
      items: [],
      location: { },
    }
  },
  computed: {
  },
  created () {
    this.emissionId = Number(this.$route.params.id)
    this.searchEmissionItems()
  },
  methods: {
    ...mapActions('DriverMasterEmissionItem', {
      fetchEmissionItems: 'show',
      deleteEmissionItem: 'destroy',
    }),
    addButtonClickEvent () {
      this.enableItemDialog = true
    },
    deleteButtonClickEvent(item) {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteEmissionItem({ emission_id: this.emissionId, id: item.id }).then(() =>{
            this.page = 1
            this.searchEmissionItems()
          })
        }
      })
    },
    closeItemDialog () {
      this.enableItemDialog = false
    },
    itemDialogCallback () {
      this.enableItemDialog = false
      this.searchEmissionItems()
    },
    changePage () {
      this.searchEmissionItems()
    },
    searchEmissionItems () {
      this.fetchEmissionItems({ emission_id: this.emissionId, page: this.page }).then((content) => {
        this.items = content.items
        this.pagination = content.pagination
      })
    },
  },
}
</script>

<style scoped lang="scss">
.wrap_text {
  display: inline-block;
  overflow-wrap: break-word;
}
</style>
